import { YHistoryEditor } from '@slate-yjs/core';

import type { CollaborationEditor } from '../collaboration/collaboration-editor';

export type LocalHistoryRequiredEditor = CollaborationEditor;

export type LocalHistoryEditor = YHistoryEditor &
  LocalHistoryRequiredEditor & {
    __localHistoryEditor: true;
  };

export const LocalHistoryEditor = {
  ...YHistoryEditor,
};
